export default "__VITE_ASSET__CcUJXudS__"